<template>
  <div>
    <v-dialog v-model="loading_download" persistent width="300">
      <v-card color="#4EBCA6" dark class="pt-1">
        <v-card-text class="text-center">
          <div class="pt-2 white--text font-16">
            {{ text_loading }}
          </div>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-container fluid class="pt-6 px-10 stylecard" style="min-height: 100vh">
      <h3 class="pb-2 pt-14 pl-2" style="color: #00a99d; font-size: 25px">
        ตรวจสุขภาพ &nbsp; > &nbsp;ผลตรวจสุขภาพ
      </h3>
      <div style="margin-top: 30px"></div>
      <v-row
        no-gutters
        class="ml-1 mr-2 my-2 mt-8"
        v-if="role_name != 'เจ้าหน้าที่ HR'"
      >
        <v-spacer></v-spacer>
        <v-col cols="12" sm="12" md="2" lg="2" xl="2" class="pa-2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="#00a99d"
                dark
                outlined
                href="files/Template health check.xlsx"
                v-bind="attrs"
                v-on="on"
                block
                class="card-medium-download"
              >
                <v-icon class="mr-2">mdi-download</v-icon>
                <span style="text-transform: capitalize">Download Excel</span>
              </v-btn>
            </template>
            <span
              ><span style="color: #ff9e00">*หมายเหตุ:</span>
              หากมีรายการตรวจเพิ่มเติมใน TreatmentEtc ให้บันทึกการตรวจในรูปแบบ
              รายการตรวจ_ ผลตรวจ_ ค่าปกติ_ ผลสรุป_</span
            ><br />
            <span
              >ตามด้วยหมายเลขลำดับการตรวจ เช่น รายการตรวจ_1 ผลตรวจ_1 ค่าปกติ_1
              ผลสรุป_1</span
            >
          </v-tooltip>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="pa-2 pr-0">
          <v-btn
            class="card-medium"
            color="#00a99d"
            dark
            block
            @click="dialog_excel = true"
            ><v-icon class="mr-2">mdi-plus-circle</v-icon
            >เพิ่มผลตรวจสุขภาพ(Excel)</v-btn
          >
        </v-col>
      </v-row>
      <v-row
        no-gutters
        align="center"
        class="pt-2"
        v-if="role_name != 'เจ้าหน้าที่ HR'"
      >
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="4"
          lg="2"
          style="min-width: 20%"
          class="pa-1"
          v-for="(item, index) in statusList"
          :key="index"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="filterStatus(index)"
            :color="filter_status == index ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row no-gutters>
              <img
                :src="
                  filter_status == index
                    ? require('../../assets/icon/medcert/' + item.imgActive)
                    : require('../../assets/icon/medcert/' + item.img)
                "
                class="ml-3 pa-3"
                :class="filter_status == index ? 'icon-dark' : 'icon-light'"
                alt="all"
              />
              <v-col col col-3 class="d-flex align-center justify-start">
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      class="font-18 font-weight-bold"
                      :style="`color: ${
                        filter_status == index ? '#FFFFFF' : '#00a99d'
                      };`"
                    >
                      {{ item.number }}
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      class="font-18"
                      :style="`color: ${
                        filter_status == index ? '#FFFFFF' : '#00a99d'
                      };`"
                    >
                      {{ item.title }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-row no-gutters align="center" class="pt-2" v-else>
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="4"
          lg="2"
          style="min-width: 20%"
          class="pa-1"
          v-for="(item, index) in statusListHR"
          :key="index"
        >
          <v-card
            class="d-flex align-center card-medium"
            height="70"
            @click="filterStatus(index)"
            :color="filter_status == index ? 'bg-00A99D' : 'bg-CEEFED'"
          >
            <v-row no-gutters>
              <img
                :src="
                  filter_status == index
                    ? require('../../assets/icon/medcert/' + item.imgActive)
                    : require('../../assets/icon/medcert/' + item.img)
                "
                class="ml-3 pa-3"
                :class="filter_status == index ? 'icon-dark' : 'icon-light'"
                alt="all"
              />
              <v-col col col-3 class="d-flex align-center justify-start">
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      class="font-18 font-weight-bold"
                      :style="`color: ${
                        filter_status == index ? '#FFFFFF' : '#00a99d'
                      };`"
                    >
                      {{ item.number }}
                    </span>
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0 d-flex align-center justify-center"
                  >
                    <span
                      class="font-18"
                      :style="`color: ${
                        filter_status == index ? '#FFFFFF' : '#00a99d'
                      };`"
                    >
                      {{ item.title }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-row no-gutters class="pt-5" v-if="factory_filter.length <= 0">
        <v-col
          cols="12"
          sm="12"
          md="4"
          lg="4"
          xl="4"
          class="card-search-start d-flex pa-2"
        >
          <v-autocomplete
            v-model="search"
            class="card-small"
            label="ค้นหา"
            :items="[...findPatient]"
            dense
            solo
            hide-details="auto"
            clearable
            @click:clear="(search = ''), searchPatient()"
            color="#00A99D"
            item-value="value"
            item-text="text"
            @input="searchPatient()"
            @keyup="getPatients"
          >
            <template v-slot:append>
              <v-btn text icon>
                <v-icon color="#00A99D">mdi-magnify</v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title> ไม่พบข้อมูล </v-list-item-title>
              </v-list-item>
            </template>
            <template slot="selection" slot-scope="{ item }">
              <span>{{ item.text }}</span>
            </template>
            <template slot="item" slot-scope="{ item }">
              <div class="d-flex flex-column">
                <span>{{ item.text }}</span>
              </div>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="3"
          lg="3"
          xl="3"
          class="card-search-end d-flex pa-2"
        >
          <v-autocomplete
            v-model="selectedYear"
            :items="yearOptions"
            item-text="text"
            item-value="value"
            class="card-small"
            item-color="teal darken-2"
            :menu-props="{ bottom: true, offsetY: true }"
            dense
            solo
            hide-details="auto"
            placeholder="ปี"
            color="#00A99D"
            @change="searchPatient()"
          >
            <template v-slot:append>
              <v-icon color="#00A99D" @click="menu = !menu"
                >mdi-calendar</v-icon
              >
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-row no-gutters class="pt-5" v-else>
        <v-col
          cols="12"
          sm="12"
          md="4"
          lg="4"
          xl="4"
          class="card-search-start d-flex pa-2"
        >
          <v-autocomplete
            v-model="search"
            class="card-small"
            label="ค้นหา"
            :items="[...findPatient]"
            dense
            solo
            hide-details="auto"
            clearable
            @click:clear="(search = ''), searchPatient()"
            color="#00A99D"
            item-value="value"
            item-text="text"
            @input="searchPatient()"
            @keyup="getPatients"
            @keypress.enter="searchPatient()"
          >
            <template v-slot:append>
              <v-btn text icon>
                <v-icon color="#00A99D">mdi-magnify</v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title> ไม่พบข้อมูล </v-list-item-title>
              </v-list-item>
            </template>
            <template slot="selection" slot-scope="{ item }">
              <span>{{ item.text }}</span>
            </template>
            <template slot="item" slot-scope="{ item }">
              <div class="d-flex flex-column">
                <span>{{ item.text }}</span>
              </div>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="3"
          lg="2"
          xl="2"
          class="card-search-middle d-flex pa-2"
        >
          <v-autocomplete
            v-model="selectedYear"
            :items="yearOptions"
            item-text="text"
            item-value="value"
            class="card-small"
            item-color="teal darken-2"
            :menu-props="{ bottom: true, offsetY: true }"
            dense
            solo
            hide-details="auto"
            placeholder="ปี"
            color="#00A99D"
            @change="searchPatient()"
          >
            <template v-slot:append>
              <v-icon color="#00A99D" @click="menu = !menu"
                >mdi-calendar</v-icon
              >
            </template>
          </v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="3"
          lg="3"
          xl="3"
          class="card-search-end d-flex pa-2"
        >
          <v-autocomplete
            solo
            dense
            v-model="filter_factory"
            :items="factory_filter"
            item-text="first_name_th"
            class="card-search"
            return-object
            placeholder="ค้นหาสถานประกอบการ"
            hide-details="auto"
            color="#00A99D"
            clearable
            clear-icon="mdi-close-circle"
            item-color="teal darken-2"
            @input="search_factory()"
          >
            <template v-slot:append>
              <v-icon color="#00A99D">mdi-chevron-down</v-icon>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row align="center" class="my-0">
        <v-col cols="12" align="center">
          <v-data-table
            v-if="
              (filter_status == 1 && role_name != 'แพทย์') ||
              (filter_status == 2 &&
                role_name == 'แพทย์' &&
                patient_list.length != 0)
            "
            v-model="selected"
            :headers="headers"
            :items="patient_list"
            hide-default-footer
            no-data-text="ไม่มีข้อมูล"
            :loading="loadingTable"
            loading-text="กำลังโหลดข้อมูล"
            disable-sort
            return-object
            show-select
            item-key="_id"
            :items-per-page="limit"
            class="virtual-scroll-table"
            @toggle-select-all="handleToggleSelectAll"
          >
            <template v-slot:no-data>
              <span class="font-16">ไม่มีข้อมูล</span>
            </template>

            <template v-slot:[`header.data-table-select`]>
              <v-checkbox
                v-model="checkAll"
                :value="true"
                color="rgba(0, 0, 0, 0.54)"
                @click="toggleSelectAll"
              ></v-checkbox>
            </template>

            <template v-slot:[`item.data-table-select`]="{ item }">
              <v-checkbox
                v-model="selected"
                :value="item"
                color="rgba(0, 0, 0, 0.54)"
                v-if="checkDoctor(item)"
              ></v-checkbox>
            </template>

            <template v-slot:progress>
              <v-progress-linear
                indeterminate
                height="3px"
                color="#00A99D"
                class="mx-0"
              ></v-progress-linear>
            </template>
            <template v-slot:[`item.no`]="{ item }">
              <span class="font-16">
                {{
                  page > 1
                    ? (page - 1) * limit + patient_list.indexOf(item) + 1
                    : patient_list.indexOf(item) + 1
                }}
              </span>
            </template>
            <template v-slot:[`item.year`]="{ item }">
              <span class="font-16">{{ parseInt(item.year) + 543 }}</span>
            </template>
            <template v-slot:[`item.name`]="{ item }">
              <div class="text-overflow">
                <v-tooltip bottom open-delay="400">
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      :class="
                        item.full_name_th ? 'font-16' : 'font-16 text-9a9a9a'
                      "
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{
                        item.full_name_th
                          ? item.full_name_th
                          : "ไม่พบในเวชระเบียน"
                      }}
                    </span>
                  </template>
                  <span>{{
                    item.full_name_th ? item.full_name_th : "ไม่พบในเวชระเบียน"
                  }}</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:[`item.doctor`]="{ item }">
              <div class="text-overflow2">
                <v-tooltip
                  bottom
                  open-delay="400"
                  v-if="typeof item.doctor === 'object' && item.doctor.name_th"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="font-16"
                      v-bind="attrs"
                      v-on="on"
                      :class="
                        item.doctor.name_th ? 'font-16' : 'font-16 text-9a9a9a'
                      "
                    >
                      {{ item.doctor.name_th || "-" }}
                    </span>
                  </template>
                  <span>{{ item.doctor.name_th || "-" }}</span>
                </v-tooltip>
                <span v-else class="font-16 text-9a9a9a">-</span>
              </div>
            </template>

            <template v-slot:[`item.company`]="{ item }">
              <div class="text-overflow3">
                <v-tooltip
                  bottom
                  open-delay="400"
                  v-if="item.company || typeof item.company == 'object'"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="font-16"
                      v-bind="attrs"
                      v-on="on"
                      :class="item.company ? 'font-16' : 'font-16 text-9a9a9a'"
                    >
                      {{
                        item.company && typeof item.company == "object"
                          ? item.company.company_name
                          : item.company
                          ? item.company
                          : "-"
                      }}
                    </span>
                  </template>
                  <span>{{
                    item.company && typeof item.company == "object"
                      ? item.company.company_name
                      : item.company
                      ? item.company
                      : "-"
                  }}</span>
                </v-tooltip>
                <span v-else class="font-16 text-9a9a9a">-</span>
              </div>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                v-if="item.status == 'Success'"
                color="#d5f7db"
                class="chip-border"
                ><v-icon color="#1CCE39" class="mr-2" x-small
                  >mdi-circle</v-icon
                >
                <span class="font-14" style="color: #1cce39">
                  ดำเนินการเสร็จสิ้น
                </span>
              </v-chip>
              <v-chip
                v-else-if="item.status == 'Approve'"
                color="#B3C2E5"
                class="chip-border"
                ><v-icon color="#2852b5" class="mr-2" x-small
                  >mdi-circle</v-icon
                >
                <span class="font-14" style="color: #2852b5"> รออนุมัติ </span>
              </v-chip>
              <v-chip
                v-else-if="item.status == 'Wait'"
                color="#fbf5eb"
                class="chip-border"
                ><v-icon color="#ffb649" class="mr-2" x-small
                  >mdi-circle</v-icon
                >
                <span class="font-14" style="color: #ffb649">
                  กำลังดำเนินการ
                </span>
              </v-chip>
              <v-chip
                v-else-if="item.status == 'Cancel'"
                color="#FFC2C3"
                class="chip-border"
                ><v-icon color="#FF3437" class="mr-2" x-small
                  >mdi-circle</v-icon
                >
                <span class="font-14" style="color: #ff3437"> ยกเลิก </span>
              </v-chip>
              <v-chip v-else color="#ff80823b" class="chip-border"
                ><v-icon color="#FF8082" class="mr-2" x-small
                  >mdi-circle</v-icon
                >
                <span class="font-14" style="color: #ff8082">
                  ไม่มีข้อมูล
                </span>
              </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex flex-row" style="justify-content: center">
                <div v-if="item.status == 'Wait' && role_name != 'แพทย์'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="get_health_check(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D"> mdi-file-document </v-icon>
                      </v-btn>
                    </template>
                    <span>ผลตรวจ</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="get_health_check(item, 'process')"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D">mdi-send </v-icon>
                      </v-btn>
                    </template>
                    <span>ส่งอนุมัติ</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="openCancelDialog(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#E26269"
                        icon
                      >
                        <v-icon color="#E2626">mdi-close-thick </v-icon>
                      </v-btn>
                    </template>
                    <span>ยกเลิก</span>
                  </v-tooltip>
                </div>
                <div
                  v-else-if="item.status == 'Approve' && role_name == 'แพทย์'"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="get_health_check(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D"> mdi-file-document </v-icon>
                      </v-btn>
                    </template>
                    <span>ผลตรวจ</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="get_health_check(item, 'process')"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D"> mdi-pencil </v-icon>
                      </v-btn>
                    </template>
                    <span>อนุมัติ</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="openreversDialog(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D">
                          mdi-arrow-u-left-bottom
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>ส่งกลับแก้ไข</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="openCancelDialog(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#E26269"
                        icon
                      >
                        <v-icon color="#E2626">mdi-close-thick </v-icon>
                      </v-btn>
                    </template>
                    <span>ยกเลิก</span>
                  </v-tooltip>
                </div>
              </div>
            </template>
          </v-data-table>
          <v-data-table
            v-else
            :headers="headers"
            :items="patient_list"
            hide-default-footer
            no-data-text="ไม่มีข้อมูล"
            :loading="loadingTable"
            loading-text="กำลังโหลดข้อมูล"
            disable-sort
            :items-per-page="limit"
            class="virtual-scroll-table"
          >
            <template v-slot:no-data>
              <span class="font-16">ไม่มีข้อมูล</span>
            </template>

            <template v-slot:progress>
              <v-progress-linear
                indeterminate
                height="3px"
                color="#00A99D"
                class="mx-0"
              ></v-progress-linear>
            </template>
            <template v-slot:[`item.no`]="{ item }">
              <span class="font-16">
                {{
                  page > 1
                    ? (page - 1) * limit + patient_list.indexOf(item) + 1
                    : patient_list.indexOf(item) + 1
                }}
              </span>
            </template>
            <template v-slot:[`item.year`]="{ item }">
              <span class="font-16">{{ parseInt(item.year) + 543 }}</span>
            </template>
            <template v-slot:[`item.name`]="{ item }">
              <div class="text-overflow">
                <v-tooltip bottom open-delay="400">
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      :class="
                        item.full_name_th ? 'font-16' : 'font-16 text-9a9a9a'
                      "
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{
                        item.full_name_th
                          ? item.full_name_th
                          : "ไม่พบในเวชระเบียน"
                      }}
                    </span>
                  </template>
                  <span>{{
                    item.full_name_th ? item.full_name_th : "ไม่พบในเวชระเบียน"
                  }}</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:[`item.doctor`]="{ item }">
              <div class="text-overflow2">
                <v-tooltip
                  bottom
                  open-delay="400"
                  v-if="typeof item.doctor === 'object' && item.doctor.name_th"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span class="font-16" v-bind="attrs" v-on="on">
                      {{ item.doctor.name_th || "-" }}
                    </span>
                  </template>
                  <span>{{ item.doctor.name_th || "-" }}</span>
                </v-tooltip>
                <span v-else class="font-16 text-9a9a9a">-</span>
              </div>
            </template>

            <template v-slot:[`item.company`]="{ item }">
              <!-- <span :class="item.company ? 'font-16' : 'font-16 text-9a9a9a'">
                {{ item.company && typeof item.company == 'object' ? item.company.company_name : item.company ? item.company : "-" }}
              </span> -->
              <div class="text-overflow3">
                <v-tooltip
                  bottom
                  open-delay="400"
                  v-if="
                    item.company ||
                    (item.company && typeof (item.company == 'object'))
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="font-16"
                      v-bind="attrs"
                      v-on="on"
                      :class="item.company ? 'font-16' : 'font-16 text-9a9a9a'"
                    >
                      {{
                        item.company && typeof item.company == "object"
                          ? item.company.company_name
                          : item.company
                          ? item.company
                          : "-"
                      }}
                    </span>
                  </template>
                  <span>{{
                    item.company && typeof item.company == "object"
                      ? item.company.company_name
                      : item.company
                      ? item.company
                      : "-"
                  }}</span>
                </v-tooltip>
                <span v-else class="font-16 text-9a9a9a">-</span>
              </div>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                v-if="item.status == 'Success'"
                color="#d5f7db"
                class="chip-border"
                ><v-icon color="#1CCE39" class="mr-2" x-small
                  >mdi-circle</v-icon
                >
                <span class="font-14" style="color: #1cce39">
                  ดำเนินการเสร็จสิ้น
                </span>
              </v-chip>
              <v-chip
                v-else-if="item.status == 'Approve'"
                color="#B3C2E5"
                class="chip-border"
                ><v-icon color="#2852b5" class="mr-2" x-small
                  >mdi-circle</v-icon
                >
                <span class="font-14" style="color: #2852b5"> รออนุมัติ </span>
              </v-chip>
              <v-chip
                v-else-if="item.status == 'Wait'"
                color="#fbf5eb"
                class="chip-border"
                ><v-icon color="#ffb649" class="mr-2" x-small
                  >mdi-circle</v-icon
                >
                <span class="font-14" style="color: #ffb649">
                  กำลังดำเนินการ
                </span>
              </v-chip>
              <v-chip
                v-else-if="item.status == 'Cancel'"
                color="#FFC2C3"
                class="chip-border"
                ><v-icon color="#FF3437" class="mr-2" x-small
                  >mdi-circle</v-icon
                >
                <span class="font-14" style="color: #ff3437"> ยกเลิก </span>
              </v-chip>
              <v-chip v-else color="#ff80823b" class="chip-border"
                ><v-icon color="#FF8082" class="mr-2" x-small
                  >mdi-circle</v-icon
                >
                <span class="font-14" style="color: #ff8082">
                  ไม่มีข้อมูล
                </span>
              </v-chip>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex flex-row" style="justify-content: center">
                <div v-if="item.status == 'Wait' && role_name == 'แพทย์'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="get_health_check(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D"> mdi-file-document </v-icon>
                      </v-btn>
                    </template>
                    <span>ผลตรวจ</span>
                  </v-tooltip>
                </div>
                <div v-if="item.status == 'Wait' && role_name != 'แพทย์'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="get_health_check(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D"> mdi-file-document </v-icon>
                      </v-btn>
                    </template>
                    <span>ผลตรวจ</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="get_health_check(item, 'process')"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D">mdi-send </v-icon>
                      </v-btn>
                    </template>
                    <span>ส่งอนุมัติ</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="openCancelDialog(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#E26269"
                        icon
                      >
                        <v-icon color="#E2626">mdi-close-thick </v-icon>
                      </v-btn>
                    </template>
                    <span>ยกเลิก</span>
                  </v-tooltip>
                </div>
                <div
                  v-else-if="item.status == 'Approve' && role_name != 'แพทย์'"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="noti(item)"
                        :disabled="check_noti(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D"> mdi-bell </v-icon>
                      </v-btn>
                    </template>
                    <span>แจ้งเตือน</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="get_health_check(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D"> mdi-file-document </v-icon>
                      </v-btn>
                    </template>
                    <span>ผลตรวจ</span>
                  </v-tooltip>
                </div>
                <div
                  v-else-if="item.status == 'Approve' && role_name == 'แพทย์'"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="get_health_check(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D"> mdi-file-document </v-icon>
                      </v-btn>
                    </template>
                    <span>ผลตรวจ</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="get_health_check(item, 'process')"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D"> mdi-pencil </v-icon>
                      </v-btn>
                    </template>
                    <span>อนุมัติ</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="openreversDialog(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D">
                          mdi-arrow-u-left-bottom
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>ส่งกลับแก้ไข</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="openCancelDialog(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#E26269"
                        icon
                      >
                        <v-icon color="#E2626">mdi-close-thick </v-icon>
                      </v-btn>
                    </template>
                    <span>ยกเลิก</span>
                  </v-tooltip>
                </div>
                <div v-else-if="item.status == 'Success'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="get_health_check(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D"> mdi-file-document </v-icon>
                      </v-btn>
                    </template>
                    <span>ผลตรวจ</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="download_pdf(item)"
                        :disabled="check_signed(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D"> mdi-download </v-icon>
                      </v-btn>
                    </template>
                    <span>ดาวน์โหลด</span>
                  </v-tooltip>
                     <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="openCancelDialog(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#E26269"
                        icon
                      >
                        <v-icon color="#E2626">mdi-close-thick </v-icon>
                      </v-btn>
                    </template>
                    <span>ยกเลิก</span>
                  </v-tooltip>
                </div>
                <div v-else-if="item.status == 'Cancel'">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="get_health_check(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="#00A99D"
                        icon
                      >
                        <v-icon color="#00A99D"> mdi-file-document </v-icon>
                      </v-btn>
                    </template>
                    <span>ผลตรวจ</span>
                  </v-tooltip>
                </div>
              </div>
            </template>
          </v-data-table>
          <v-row
            v-if="selected.length != 0"
            class="ml-0 mt-0 mb-0"
            style="width: 100%"
          >
            <v-btn
              v-if="
                (filter_status == 1 && role_name != 'แพทย์') ||
                (filter_status == 2 &&
                  role_name == 'แพทย์' &&
                  patient_list.length != 0)
              "
              @click="send_document(selected)"
              block
              dark
              color="#00a99d"
            >
              <span v-if="filter_status == 1">ส่งอนุมัติ</span>
              <span v-if="filter_status == 2">อนุมัติ</span>
            </v-btn>
          </v-row>
          <Pagination
            :totals="total"
            :isPage="page"
            @page="change_page"
            :max="limit"
            :showSetMax="true"
            @setLimit="setLimit"
          />
          <cancelDialog
            ref="cancelDialog"
            from="patientList"
            @close="get_all_transactions"
          />
          <Reversdialog
            ref="Reversdialog"
            from="patientList"
            @close="get_all_transactions"
          />
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialog_excel"
        persistent
        content-class="alldialog_settings"
        max-width="600px"
      >
        <v-card class="pb-3 pt-1">
          <v-form ref="file" @submit.prevent="submit_form()">
            <v-card-title class="px-8">
              <span class="font-24 text-00A99D w-700"
                >เพิ่มผลตรวจสุขภาพ(Excel)</span
              >
              <v-spacer></v-spacer>
              <v-btn icon color="#00a99d" text @click="close">
                <v-icon color="#00a99d">mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="py-5 px-8">
              <v-col cols="12" class="py-1 px-0">
                <v-file-input
                  v-model="files"
                  color="#00A99D"
                  counter
                  accept=".xlsx"
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
                  :rules="rule_file"
                  dense
                >
                  <template v-slot:label>
                    <span class="text-313B41 w-500 font-14">เพิ่มไฟล์</span>
                  </template>
                  <template v-slot:selection="{ text }">
                    <v-chip color="#00A99D" dark label small
                      >{{ text }}
                    </v-chip>
                  </template>
                </v-file-input>
              </v-col>
            </v-card-text>
            <v-card-actions class="px-8">
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="6" lg="auto" md="auto" sm="auto">
                  <v-btn
                    block
                    color="error"
                    outlined
                    @click="close()"
                    depressed
                    class="font-16 w-500 card-medium-cancel px-8"
                    >ยกเลิก</v-btn
                  >
                </v-col>
                <v-col cols="6" lg="auto" md="auto" sm="auto">
                  <v-btn
                    block
                    :disabled="is_add_file"
                    color="#00A99D"
                    type="submit"
                    depressed
                    class="font-16 w-500 card-medium px-8"
                    style="color: white"
                    >ตกลง</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="alert_dialog" scrollable persistent max-width="1000px">
        <v-card>
          <v-card-title class="justify-center">
            รายงานผลข้อผิดพลาด
          </v-card-title>
          <v-card-text style="max-height: 400px">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">เลขประจำตัวประชาชน</th>
                    <th class="text-left">ปี</th>
                    <th class="text-left">หมายเหตุ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in item_alert" :key="item.personalId">
                    <td>{{ item.personalId }}</td>
                    <td>{{ item.year }}</td>
                    <td>{{ item.message }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-title class="justify-center">
            <div class="d-flex flex-column align-center">
              <span>กรุณาเลือกไฟล์ใหม่อีกครั้ง</span>
              <div style="font-size: 14px">
                <span style="color: red">*</span
                ><span>กดดาวน์โหลดไฟล์เพื่อดาวน์โหลดรายงานผลข้อผิดพลาด</span>
              </div>
            </div>
          </v-card-title>
          <v-card-actions class="justify-center">
            <v-btn
              color="#00a99d"
              style="color: white"
              @click="alert_dialog = false"
              class="card-medium"
              >ตกลง</v-btn
            >
            <v-btn
              outlined
              color="#00a99d"
              @click="downloadExcelAlert()"
              class="card-medium-cancel"
              >ดาวน์โหลดไฟล์</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isDialogSelectDoctor"
        max-width="500px"
        style="border-radius: 8px"
      >
        <v-card>
          <v-card-title> เลือกแพทย์ </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-col cols="12">
                  <span style="font-size: 16px">
                    แพทย์ <span style="color: red">*</span>
                  </span>
                  <v-combobox
                    attach
                    v-model="select_doc"
                    placeholder="ชื่อแพทย์"
                    :item="searchDoc"
                    outlined
                    dense
                    hide-details
                    :items="searchDoc"
                    @input="searchDoctor"
                    item-text="name_th"
                    return-object
                    class="mt-1"
                    :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                    color="#00A99D"
                  >
                    <template v-slot:append>
                      <img
                        src="@/assets/icon/medcert/search.svg"
                        alt="search"
                      />
                    </template>
                  </v-combobox>
                </v-col>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pb-4 text-rigth">
            <v-spacer></v-spacer>
            <v-btn
              @click="isDialogSelectDoctor = false"
              color="red"
              style="color: white"
              >ยกเลิก</v-btn
            >
            <v-btn
              @click="confirmSelectDoctor()"
              :disabled="
                select_doc.length === 0 ||
                !select_doc ||
                select_doc === undefined ||
                !select_doc.one_id
              "
              color="#00A99D"
              style="color: white"
              >ส่งอนุมัติ</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { Pagination } from "@/components/pagination/";
import { mapState, mapMutations } from "vuex";
import { EventBus } from "@/EventBus";
import XLSX from "xlsx";
import moment from "moment";
import cancelDialog from "../../components/dialog/Canceldialog_helthcheck.vue";
import Reversdialog from "../../components/dialog/Reversdialog_helthcheck.vue";

//dialog
// import { EventBus } from "@/EventBus";

// import moment from "moment";

export default {
  components: {
    Pagination,
    cancelDialog,
    Reversdialog,
  },
  data() {
    return {
      loadingTable: false,
      today: moment().format("YYYY-MM-DD"),
      filter_status: 0,
      menu: false,
      isDialogSelectDoctor: false,
      checkAll: [],
      searchDoc: [],
      select_doc: [],
      is_select_doc: true,
      statusList: [
        {
          title: "ทั้งหมด",
          number: 0,
          img: "all-light.svg",
          imgActive: "all-dark.svg",
        },
        {
          title: "รอกรอก",
          number: 0,
          img: "transport.svg",
          imgActive: "transport.svg",
        },
        {
          title: "รออนุมัติ",
          number: 0,
          img: "pencil-line.svg",
          imgActive: "pencil-line.svg",
        },
        {
          title: "สำเร็จ",
          number: 0,
          img: "success.svg",
          imgActive: "success.svg",
        },
        {
          title: "ยกเลิก",
          number: 0,
          img: "close-outline.svg",
          imgActive: "close-outline.svg",
        },
        // {title: "ยกเลิก", number: 0, img: "cancle.svg"},
      ],
      statusListHR: [
        {
          title: "สำเร็จ",
          number: 0,
          img: "success.svg",
          imgActive: "success.svg",
        },
        // {title: "ยกเลิก", number: 0, img: "cancle.svg"},
      ],
      patientList: [],
      headers: [
        {
          text: "ลำดับ",
          value: "no",
          sortable: false,
          align: "center",
          width: "5%",
        },
        {
          text: "ชื่อผู้เข้ารับการตรวจสุขภาพ",
          align: "left",
          sortable: false,
          value: "name",
          width: "15%",
        },
        {
          text: "แพทย์ผู้ตรวจ",
          align: "center",
          sortable: false,
          value: "doctor",
          width: "20%",
        },
        {
          text: "สถานประกอบการผู้เข้ารับการตรวจ",
          align: "center",
          sortable: false,
          value: "company",
          width: "15%",
        },
        {
          text: "การตรวจประจำปี",
          align: "center",
          sortable: false,
          width: "12%",
          value: "year",
        },
        {
          text: "สถานะ",
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: "Action",
          value: "actions",
          sortable: false,
          align: "center",
          width: "250px",
        },
      ],
      total: 0,
      page: 1,
      loading_download: false,
      role_name: sessionStorage.role_name,
      selectedYear: null,
      dialog_excel: false,
      yearOptions: [],
      patient_list: [],
      rule_file: [(v) => !!v || "กรุณาเลือกไฟล์ข้อมูล"],
      files: [],
      is_add_file: true,
      alert_dialog: false,
      search: "",
      selected: [],
      status: "",
      list_document: [],
      text_loading: "",
      limit: 100,
      factory_filter: [],
      filter_factory: "",
      findPatient: [],
      selectDoctor: {},
    };
  },
  async created() {
    await this.getfactory_filter();
    await this.getPatients();
    if (sessionStorage.role_name == "แพทย์") {
      this.filter_status = 2;
    } else if (sessionStorage.role_name == "เจ้าหน้าที่ HR") {
      this.filter_status = 0;
    } else {
      this.filter_status = 1;
    }
    await this.get_all_transactions();
    if (this.healthCheck_notification !== null) {
      const itemData = this.patient_list.find(
        (itemData) => itemData._id === this.healthCheck_notification.ref
      );
      if (itemData && itemData.status !== "Success") {
        this.get_health_check(itemData, "noti");
      }
    }
    this.filter_factory = {
      _id: "",
      first_name_th: "ทั้งหมด",
      biz_id: "all",
      taxid: "",
      type: "",
    };
  },
  async mounted() {
    EventBus.$on("searchNotification", (item) => {
      this.get_all_transactions();
      if (item !== undefined) {
        const itemData = this.patient_list.find(
          (itemData) => itemData._id === item.ref
        );
        if (itemData && itemData.status !== "Success") {
          this.get_health_check(itemData, "noti");
        }
      }
    });
    this.generateYearOptions();
  },
  computed: {
    ...mapState(["healthCheck_notification"]),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
  },
  beforeDestroy() {
    EventBus.$off("getData");
    EventBus.$off("searchNotification");
  },
  watch: {
    files(val) {
      if (val) {
        this.is_add_file = false;
      } else {
        this.is_add_file = true;
      }
    },
    select_doc: {
      handler(new_val) {
        if (new_val === null || new_val === "") {
          this.is_select_doc = true;
        } else {
          this.is_select_doc = false;
        }
      },
      deep: true,
    },
  },
  sockets: {
    connect() {
      console.log("connect sockets io");
    },
    health_check_file(res) {
      if (res) {
        this.get_all_transactions();
      }
    },
  },
  methods: {
    ...mapMutations([
      "setStatusPhysicalExam",
      "setDetailPhysicalExam",
      "clearStateNotification",
    ]),
    async get_all_transactions() {
      try {
        var keysearch = this.search;
        if (keysearch === null || keysearch === undefined) {
          keysearch = "";
        } else keysearch = this.search.one_id;
        this.checkAll = [];
        this.selected = [];
        this.loadingTable = true;
        this.patient_list = [];
        const params = new URLSearchParams();
        params.append("biz_id", sessionStorage.getItem("biz_id"));
        params.append("year", this.selectedYear ? this.selectedYear - 543 : "");
        params.append("search", keysearch || "");
        params.append("limit", this.limit);
        params.append("page", this.page || "1");
        if (this.filter_status == 1) {
          params.append("status", "Wait");
        } else if (this.filter_status == 2) {
          params.append("status", "Approve");
        } else if (
          this.filter_status == 3 ||
          (this.filter_status == 0 && this.role_name == "เจ้าหน้าที่ HR")
        ) {
          params.append("status", "Success");
        } else if (this.filter_status == 4) {
          params.append("status", "Cancel");
        }
        if (this.filter_factory && this.filter_factory.biz_id != "all") {
          params.append("factory_id", this.filter_factory.biz_id);
        }
        if (sessionStorage.role_name === "แพทย์")
          params.append("doctor_id", sessionStorage.oneId);
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v2/findByBiz?${params}`)
          // .get(`http://localhost:5000/v2/findByBiz?${params}`)
          .then((res) => {
            // console.log('res',res);
            if (res.data.result === "success") {
              // setTimeout(() => {

              // }, 1000);
              res.data.data.forEach((element) => {
                element.fullname = `${
                  element.account_title_th ? element.account_title_th : ""
                }${element.first_name_th ? element.first_name_th : ""} ${
                  element.last_name_th ? element.last_name_th : ""
                }`;
              });
              this.patient_list = Object.assign([], res.data.data);
              if (this.filter_status == 1) {
                this.total = res.data.count.wait;
              } else if (this.filter_status == 2) {
                this.total = res.data.count.approve;
              } else if (
                this.filter_status == 3 ||
                (this.filter_status == 0 && this.role_name == "เจ้าหน้าที่ HR")
              ) {
                this.total = res.data.count.success;
              } else if (this.filter_status == 4) {
                this.total = res.data.count.cancel;
              } else {
                this.total = res.data.count.total;
              }
              this.statusList[0].number = res.data.count.total;
              this.statusList[1].number = res.data.count.wait;
              this.statusList[2].number = res.data.count.approve;
              this.statusList[3].number = res.data.count.success;
              this.statusList[4].number = res.data.count.cancel;
              this.statusListHR[0].number = res.data.count.success;
              this.loadingTable = false;
            }
          })
          .catch((err) => {
            console.log("axios get transactions err: ", err.message);
          });
      } catch (error) {
        console.log("get all transactions error:", error.message);
      }
    },
    getPatients(text) {
      try {
        let limit = 1000;
        let word = "";
        if (text === undefined) {
          word = "";
        } else word = text.target.value;
        this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/patients/search?biz_id=${sessionStorage.biz_id}&search=${word}&limit=${limit}`
          )
          .then((res) => {
            const getdata = res.data.data[0];
            if (getdata.data.length != 0) {
              this.findPatient = [];
              getdata.data.forEach((ele) => {
                this.findPatient.push({
                  text: ele.first_name_th + " " + ele.last_name_th,
                  mobile: ele.mobile,
                  value: ele,
                });
              });
            }
          });
      } catch (error) {
        console.error();
      }
    },
    async getfactory_filter() {
      try {
        const params = new URLSearchParams();
        params.append("biz_id", sessionStorage.biz_id);
        params.append("filter_status", "true");
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/organization/getFactoryhospital?${params}`
          )
          // .get(`http://localhost:5000/v1/organization/getFactoryhospital?${params}`)
          .then((res) => {
            if (res.data.result == "success") {
              this.factory_filter = res.data.data;
              this.factory_filter.unshift({
                _id: "",
                first_name_th: "ทั้งหมด",
                biz_id: "all",
                taxid: "",
                type: "",
              });
            }
          });
      } catch (error) {
        console.error();
      }
    },
    generateYearOptions() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let year = currentYear; year >= currentYear - 10; year--) {
        years.push({ value: year + 543, text: year + 543 });
      }
      this.yearOptions = years;
      this.yearOptions.unshift({ value: "", text: "ทั้งหมด" });
    },
    readExcelFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            // อ่านข้อมูลจาก sheet แรก
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
            // คืนค่าจำนวน row
            console.log("jsonData", jsonData);

            if (jsonData.length > 0) {
              resolve([
                jsonData.filter((val) => val.length > 0).length,
                jsonData[0][0] === "HN" &&
                  jsonData[0][1] === "ชื่อ-นามสกุล" &&
                  jsonData[0][2] === "รหัสพนักงาน",
              ]);
            } else {
              resolve([0, false]);
            }
          } catch (error) {
            reject(error); // หากเกิดข้อผิดพลาด
          }
        };

        reader.onerror = (error) => reject(error); // กรณีอ่านไฟล์ล้มเหลว
        reader.readAsArrayBuffer(file); // อ่านไฟล์
      });
    },
    async submit_form() {
      let form_data = new FormData();
      let file = this.files;
      let rowCount = 0;
      if (file) {
        try {
          rowCount = await this.readExcelFile(file);
          console.log("rowCount", rowCount);
        } catch (error) {
          console.error("เกิดข้อผิดพลาดในการอ่านไฟล์:", error);
        }
      }

      if (rowCount[1] === false) {
        this.$swal.fire(
          "ไม่สามารถเพิ่มไฟล์ได้",
          "ข้อมูลในไฟล์ไม่ถูกต้อง",
          "warning"
        );
        return;
      }
      if (rowCount[0] <= 1) {
        this.$swal.fire(
          "ไม่สามารถเพิ่มไฟล์ได้",
          "ไม่มีข้อมูลในไฟล์",
          "warning"
        );
        return;
      }
      form_data.append("health_check_data", file);
      form_data.append("oneid_import", sessionStorage.getItem("account_id"));
      form_data.append("name_import", sessionStorage.getItem("accountName"));

      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      await this.axios
        .post(
          `${
            process.env.VUE_APP_BACKEND_URL
          }/v3/importExcel?biz_id=${sessionStorage.getItem("biz_id")}`,
          form_data,
          config
        )
        .then(async (response) => {
          if (response.data.result === "success") {
            this.$swal.fire({
              icon: "success",
              title: "บันทึกข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1000,
            });
            this.close();
            await this.get_all_transactions();
          } else if (response.data.result === "Departments already exist!") {
            this.$swal.fire(
              "ข้อมูลนี้ถูกใช้ไปแล้ว",
              "กรุณาเลือกไฟล์ใหม่อีกครั้ง",
              "warning"
            );
          } else if (response.data.message === "excelfile is not found") {
            this.$swal.fire(
              "ไม่พบข้อมูล",
              "กรุณาเลือกข้อมูลก่อนกดบันทึก",
              "warning"
            );
          } else {
            this.$swal.fire("ผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "error");
          }
          this.clear();
        })
        .catch((err) => {
          // console.log(err);
          this.$swal.fire("เกิดข้อผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "error");
          if (
            err.response.data.fail_result &&
            err.response.data.fail_result.length > 0
          ) {
            this.item_alert = err.response.data.fail_result;
            this.alert_dialog = true;
          }
        });
    },
    async download_pdf(item) {
      try {
        if (item.file_id) {
          this.loading_download = true;
          this.text_loading = "กำลังดาวน์โหลดเอกสาร";
          const doc_code = "HEALTH_CHECK";
          await this.axios
            .get(
              `${process.env.VUE_APP_BACKEND_URL}/v1/sign/downloadpdf?id=${item._id}&doc_code=${doc_code}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  "Content-Disposition": 'attachment; filename="file.pdf"',
                },
                responseType: "blob",
              }
            )
            .then((res) => {
              const blob = new Blob([res.data], { type: "application/pdf" });
              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = "ผลตรวจสุขภาพประจำปี.pdf"; // ตั้งชื่อไฟล์ที่จะดาวน์โหลด
              link.click();
              this.loading_download = false;
            })
            .catch((err) => {
              this.loading_download = false;
              console.log("axios download pdf err:", err.message);
            });
        } else {
          this.genPdf_base(item._id);
        }
      } catch (error) {
        this.loading_download = false;
        console.log("function download pdf error:", error.message);
      }
    },
    async genPdf_base(item) {
      try {
        this.loading_download = true;
        this.text_loading = "กำลังดาวน์โหลดเอกสาร";
        const payload = {
          doc_id: item,
        };
        await this.axios
          .post(
            `${process.env.VUE_APP_BACKEND_URL}/v2/sign/create-pdf`,
            payload
          )
          .then(async (res) => {
            console.log("🚀 ~ res:", res);
            const base64Data = res.data.data;
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });

            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "ผลตรวจสุขภาพประจำปี.pdf";
            link.click();

            this.loading_download = false;
          });
      } catch (err) {
        this.loading_download = false;
        console.log(err);
      }
    },
    async get_health_check(item, status) {
      // console.log("item", item);
      // console.log("status", status);
      let patient_id = "";
      if (!item.patient_id) {
        try {
          let params = new URLSearchParams();
          params.append("id", item._id);
          params.append("year", item.year);
          params.append("biz_id", sessionStorage.getItem("biz_id"));

          await this.axios
            .get(`${process.env.VUE_APP_BACKEND_URL}/v1/findOneForm?${params}`)
            .then((res) => {
              if (res.data.result === "success") {
                patient_id = res.data.data.patient_id;
              }
            });
        } catch (err) {
          console.log("err", err);
        }
      }

      if (status) {
        item.send_data = true;
        this.setStatusPhysicalExam({ tab: 6 });
        this.setDetailPhysicalExam(item);
      } else {
        this.setStatusPhysicalExam(null);
        const params = new URLSearchParams();
        params.append("id", item.patient_id || patient_id);
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v1/patients?${params}`)
          .then((res) => {
            if (res.data.data) {
              item.company = res.data.data.company;
              item.position = res.data.data.position;
              item.department = res.data.data.department;
              item.employee_id = res.data.data.employee_id;
              item.birth_date = res.data.data.birth_date;
              item.age = res.data.data.age;
              item.patient_id = res.data.data._id;
            }
          })
          .catch((err) => {
            console.log("axios get transactions err: ", err.message);
          });
        this.setDetailPhysicalExam(item);
      }
      this.$router.push({ name: "PhysicalExam" });
    },
    async getPatientId(item) {
      try {
        let params = new URLSearchParams();
        params.append("id", item._id);
        params.append("year", item.year);
        params.append("biz_id", sessionStorage.getItem("biz_id"));

        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v1/findOneForm?${params}`)
          .then((res) => {
            console.log("res", res);
            if (res.data.result === "success") {
              console.log("res.data.data.patient_id", res.data.data.patient_id);

              return res.data.data.patient_id;
            }
          });
      } catch (err) {
        console.log("err", err);
      }
    },
    async change_page(e) {
      this.page = e;
      await this.get_all_transactions();
    },
    check_signed(item) {
      console.log("🚀 ~ item:", item);
      return false;
      // if (item.file_id && item.file_id !== "") {
      //   return false;
      // } else if (!item.file_id || item.file_id === "") {
      //   return true;
      // }
    },
    check_noti(item) {
      if (!item.file_id || item.file_id === "") {
        return false;
      } else if (item.file_id && item.file_id !== "") {
        return true;
      }
    },
    filterStatus(index) {
      this.filter_status = index;
      if (this.page == 1) {
        this.get_all_transactions();
      } else {
        this.page = 1;
      }
    },
    search_factory() {
      this.page = 1;
      this.get_all_transactions();
    },
    close() {
      this.dialog_excel = false;
      this.files = null;
      this.clear();
    },
    clear() {
      this.files = null;
      this.$refs.file.resetValidation();
    },
    async noti(item) {
      try {
        await this.axios
          .post(`${process.env.VUE_APP_BACKEND_URL}/v1/noti-staff`, {
            recipient_oneid: item.doctor.one_id,
            role: "แพทย์",
            biz_id: item.bizId,
            details: {
              title: "รออนุมัติการเซ็นเอกสารใบตรวจสุขภาพ",
              patient_name: item.full_name_th,
              org_name: sessionStorage.biz_name,
              message: "มีเอกสารใบตรวจสุขภาพรออนุมัติ",
            },
            type: "health_check",
            ref: item._id,
          })
          .then((res) => {
            if (res.data.result === "success") {
              this.$swal.fire({
                icon: "success",
                title: `<span style="font-size: 20px;">การแจ้งเตือนถูกส่งเรียบร้อย</span>`,
                showConfirmButton: false,
                timer: 2000,
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: `<span style="font-size: 20px;">การแจ้งเตือนผิดพลาด</span>`,
                showConfirmButton: false,
                timer: 2000,
              });
            }
          });
      } catch (err) {
        console.log(err);
        this.$swal.fire({
          icon: "error",
          title: `<span style="font-size: 20px;">การแจ้งเตือนผิดพลาด</span>`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    searchPatient() {
      this.get_all_transactions();
    },
    downloadExcelAlert() {
      let header = [
        {
          key1: "เลขประจำตัวประชาชน",
          key2: "ปี",
          key3: "sheet",
          key4: "หมายเหตุ",
        },
      ];
      var wscols = [{ width: 20 }, { width: 20 }, { width: 30 }, { width: 40 }];
      const dataWS = XLSX.utils.json_to_sheet(header, {
        skipHeader: true,
        origin: "A1",
      });
      XLSX.utils.sheet_add_json(dataWS, this.item_alert, {
        skipHeader: true,
        origin: "A2",
      });
      dataWS["!cols"] = wscols;
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(
        wb,
        `report ${moment().add(543, "year").format("DD_MM_YYYY")}.xlsx`
      );
    },
    openCancelDialog(item) {
      this.$refs.cancelDialog.openDialog(item);
    },
    openreversDialog(item) {
      this.$refs.Reversdialog.openDialogRevers(item);
    },
    async send_document(item) {
      console.log("🚀 ~ item:", item);
      try {
        this.$swal
          .fire({
            title: `คุณได้เลือกเอกสารจำนวน ${item.length} ไฟล์`,
            text: `ต้องการส่งไปอัปเดตหรือไม่ ?`,
            icon: "warning",
            width: 400,
            background: "white",
            position: "center",
            showCancelButton: true,
            reverseButtons: true,
            cancelButtonText: "ยกเลิก",
            confirmButtonText: "ยืนยัน",
            confirmButtonColor: "#00a99d",
          })
          .then(async (res) => {
            if (res.isConfirmed) {
              if (this.role_name == "แพทย์") {
                this.loading_download = true;
                this.text_loading = "กำลังส่งเอกสาร";
              }
              let list_document = [];
              item.forEach((element) => {
                list_document.push(element._id);
              });
              this.list_document = list_document;

              if (this.role_name != "แพทย์") {
                this.getStaff();
                this.isDialogSelectDoctor = true;
                // await this.axios
                // .put(
                //   `${process.env.VUE_APP_BACKEND_URL}/v1/updatestatus_healtcheckgroup`,
                //   payload
                // )
                // .then(async(res) => {
                //   this.loading_download = false
                //   if (res.data.result === "success") {
                //     this.$swal.fire({
                //       icon: "success",
                //       title: `<span style="font-size: 20px;">ส่งเอกสารสำเร็จ</span>`,
                //       showConfirmButton: false,
                //       timer: 2000,
                //     });
                //     await this.get_all_transactions();
                //   } else {
                //     this.$swal.fire({
                //       icon: "error",
                //       title: `<span style="font-size: 20px;">เกิดข้อผิดพลาด</span>`,
                //       showConfirmButton: false,
                //       timer: 2000,
                //     });
                //   }
                // });
              } else {
                const payload = {
                  doc_list: this.list_document,
                  biz_id: sessionStorage.biz_id,
                };
                await this.axios
                  .post(
                    `${process.env.VUE_APP_BACKEND_URL}/v1/sign_group`,
                    payload
                  )
                  .then(async (res) => {
                    this.loading_download = false;
                    if (res.data.result === "success") {
                      this.$swal.fire({
                        icon: "success",
                        title: `<span style="font-size: 20px;">อนุมัติเอกสารสำเร็จ</span>`,
                        showConfirmButton: false,
                        timer: 2000,
                      });
                      this.filter_status = 3
                      await this.get_all_transactions();
                    } else {
                      this.$swal.fire({
                        icon: "error",
                        title: `<span style="font-size: 20px;">เกิดข้อผิดพลาด</span>`,
                        showConfirmButton: false,
                        timer: 2000,
                      });
                    }
                  });
              }
            }
          });
      } catch (error) {
        this.loading_download = false;
        this.$swal.fire({
          icon: "error",
          title: `<span style="font-size: 20px;">เกิดข้อผิดพลาด</span>`,
          showConfirmButton: false,
          timer: 2000,
        });
        console.log(error);
      }
    },
    setLimit(data) {
      this.limit = data;
      this.page = 1;
      this.get_all_transactions();
    },
    handleToggleSelectAll() {
      if (this.filter_status === 1) {
        this.selected = this.patient_list.filter(
          (el) =>
            (typeof el.doctor === "object" && el.doctor.name_th == "") ||
            (el.doctor && el.doctor.length == 0) ||
            !el.doctor
        );
      } else if (this.filter_status === 2) {
        this.selected = this.patient_list.filter(
          (el) => typeof el.doctor === "object" && el.doctor.name_th
        );
      }
    },
    checkDoctor(item) {
      if (this.filter_status == 1) {
        return (
          (typeof item.doctor === "object" && item.doctor.name_th == "") ||
          (item.doctor && item.doctor.length == 0) ||
          !item.doctor
        );
      } else if (this.filter_status == 2) {
        return typeof item.doctor === "object" && item.doctor.name_th;
      }
      return true;
    },
    toggleSelectAll() {
      if (this.checkAll.length === 1) {
        if (this.filter_status === 1) {
          this.selected = this.patient_list.filter(
            (el) =>
              (typeof el.doctor === "object" && el.doctor.name_th == "") ||
              (el.doctor && el.doctor.length == 0) ||
              !el.doctor
          );
        } else if (this.filter_status === 2) {
          this.selected = this.patient_list.filter(
            (el) => typeof el.doctor === "object" && el.doctor.name_th
          );
        }
      } else {
        this.selected = [];
      }
    },
    async getStaff() {
      try {
        let params = new URLSearchParams();
        params.append("biz_id", sessionStorage.biz_id);
        params.append("mode", "all-doctor");
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v1/getStaff?${params}`)
          .then((res) => {
            this.searchDoc = res.data.data;
          });
      } catch (err) {
        console.log(err);
      }
    },
    searchDoctor() {
      if (this.is_select_doc) {
        this.selectDoctor = {
          biz_id: this.select_doc.biz_id,
          doctor_license: this.select_doc.doctor_license,
          name_th: this.select_doc.name_th,
          one_id: this.select_doc.one_id,
        };
      }
    },
    async confirmSelectDoctor() {
      try {
        this.loading_download = true;
        this.text_loading = "กำลังส่งอนุมัติเอกสาร";
        const payload = {
          doc_list: this.list_document,
          doctor: this.selectDoctor,
        };
        await this.axios
          .post(
            `${process.env.VUE_APP_BACKEND_URL}/v1/send-waiting-approve`,
            payload
          )
          .then((res) => {
            if (res.data.result == "success") {
              this.loading_download = false;
              this.filter_status = 2;
              this.get_all_transactions();
              this.clearDialog();
              this.$swal.fire({
                icon: "success",
                title: "ส่งอนุมัติสำเร็จ",
                showConfirmButton: false,
                timer: 2000,
              });
            } else {
              this.clearDialog();
              this.$swal({
                title:
                  "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>ส่งอนุมัติไม่สำเร็จ</span>",
                icon: "error",
                showCloseButton: false,
                showConfirmButton: false,
                background: "white",
                timer: 3000,
              });
            }
          });
      } catch (err) {
        console.log(err);
      }
    },
    clearDialog() {
      this.isDialogSelectDoctor = false;
      this.select_doc = [];
    },
  },
};
</script>

<style scoped>
.card-small {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}

.stylecard {
  /* bg */
  position: absolute;
  /* white */
  background: #fbfffe;
  border-radius: 80px 0px 0px 0px;
}

.card-medium {
  background: #ceefed;
  border-radius: 20px 5px;
  box-shadow: none !important;
}
.card-medium-download {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}

.card-medium-cancel {
  /* background: #ceefed; */
  border-radius: 20px 5px;
  box-shadow: none !important;
}

.theme-back {
  background-color: #00a99d;
  color: #ffffff;
}

.icon-dark {
  background: #ceefed;
  border-radius: 16px 5px;
  padding: 5px;
}
.icon-light {
  background: #00a99d;
  border-radius: 16px 5px;
  padding: 5px;
}
.card-search {
  background: #ceefed;
  border-radius: 20px 5px;
}

::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.5rem !important;
}

::v-deep .v-select__selections {
  line-height: 25px;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: 0px 0px 0px 0px !important;
}

::v-deep .v-data-table-header {
  background: #ceefed;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #00a99d;
  font-weight: 700;
  font-size: 14px !important;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table > .v-data-table__wrapper > table {
  border-spacing: 0 15px;
  background: #fff;
  /* border-collapse: separate; */
  /* border-bottom: none; */
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr {
  background: #ebf7f7;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  border-bottom: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}

.theme--light.v-data-table
  .v-data-table-header
  th.sortable
  .v-data-table-header__icon {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep
  .v-data-table
  > .v-data-table__wrapper
  .v-data-table__mobile-table-row {
  display: block !important;
  background-color: white;
}

::v-deep .v-data-table-header.v-data-table-header-mobile {
  display: none;
}

::v-deep .v-data-table-header__icon {
  display: none;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(
    .v-data-table__empty-wrapper
  ) {
  background: #ceefed !important;
}

::v-deep
  .v-text-field
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  > input {
  line-height: 1.7rem;
}

::v-deep
  .v-text-field
  > .v-input__control
  > .v-input__slot
  > .v-select__slot
  > input {
  line-height: 1.7rem;
}

.virtual-scroll-table {
  max-height: 700px;
  overflow: auto;
  width: 100vw;
}

.text-overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 150px;
}

.text-overflow2 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 150px;
}

.text-overflow3 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 150px;
}
</style>
